// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_ayC","cls2":"UpsellModalRedesign-cls2_xpi UpsellModalRedesign-cls1_ayC"};